const {h, render, Component} = require('preact');

class NoItemsView extends Component {
  constructor(props) {
    super(props);
  };

  getNoItemsText(){
    if(this.props.noOrdersFound){
      return I18n.translate("js.modules.web_2018.no_orders_text");
    }
    else if (this.props.noClaimsFound){
      return I18n.translate("js.modules.web_2018.no_claims_text");
    }
  }

  getImageClass(){
    if(this.props.noOrdersFound)
      return "no-orders-image";
    else if (this.props.noClaimsFound)
      return "no-claims-image";
  }

  getBHWTag(){
    if(this.props.noOrdersFound)
      return "web2018_no_orders_view_deal_link";
    else if (this.props.noClaimsFound)
    return "web2018_no_claims_view_deal_link";
  }

  render() {
    return (
      <div class="no-items">
        <div class={this.getImageClass()}></div>
        <p>{this.getNoItemsText()}</p>
        <a href="/" rel="noopener noreferrer" target="_blank" data-bhw={this.getBHWTag()}>
          {I18n.translate("js.modules.web_2018.view_deals")}
        </a>
      </div>
    );
  }
}
module.exports = NoItemsView
